export const SET_TABLE_MODAL_DATA = 'SET_TABLE_MODAL_DATA';
export const CLOSE_TABLE_MODAL = 'CLOSE_TABLE_MODAL';
